<div>
  <div class="loading modal-backdrop " [ngClass]="{'fade': !opacity}" *ngIf="show || !completeInit" style="z-index: 10000">
  </div>
  
  <div class="lds-ellipsis" *ngIf="show || !completeInit">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>  
</div>